import BackButton from "../../../Components/BackButton";
import RankingTable from "../../../Components/RankinkTable";
import TitlePages from "../../../Components/TitlePages";
import { useEffect, useState } from "react";
import axios from "axios"
import { useUser } from "../../../providers/UserContext";
import {
    Container,
    SizeContainer,
    Header,
    MainContainer,
    AccumulatedHeader,
    ContainerStock,
    ButtonRequest,
    ContainerConsultancy,
    ContainerSecunday,
    IconConsultancy,
    TitleConsultancy,
    ContainerSecundayConsultancy,
    ContainerInputConsultancy,
    ContainerHeaderConsultancy,
    ContainerTimer
} from "./styles.js";
import Loading from "../../../Components/Loading";
import { useHistory } from "react-router";

const NewGame = () => {
    const [timer, setTimer] = useState(0)
    const [taxaEmprestimo, setTaxaEmprestimo] = useState(0)
    const [taxaInsvestimento, setTaxaInsvestimento] = useState(0)
    const [orcamentoAlimentacao, setOrcamentoAlimentacao] = useState(0)
    const [carneConsult, setCarneConsult] = useState(0)
    const [frangoConsult, setFrangoConsult] = useState(0)
    const [frangoCorteConsult, setFrangoCorteConsult] = useState(0)
    const [linguicaConsult, setLinguicaConsult] = useState(0)
    const [populacao, setPopulacao] = useState(0)
    const [rendaPerCapita, setRendaPerCapita] = useState(0)
    const [maxInteracoes, setMaxInteracoes] = useState(0)
    const [loading, setLoading] = useState(false)
    const [rodadas, setRodadas] = useState(0)

    const { user } = useUser()

    const history = useHistory()
    const api = axios.create({
        baseURL: "https://sistemas.sisinfor.com.br/BusinessGameBack"
    })

    function clearAll() {
        setTimer(0)
        setOrcamentoAlimentacao(0)
        setCarneConsult(0)
        setFrangoConsult(0)
        setFrangoCorteConsult(0)
        setLinguicaConsult(0)
        setPopulacao(0)
        setRendaPerCapita(0)
        setMaxInteracoes(0)
        setRodadas(0)
    }


    async function handleCreateConsult(responseJogo) {

        const dataConsult = {
            "consultoria": 0,
            "jogo": responseJogo.data.mensagem,
            "orcamentoAlimentacao": orcamentoAlimentacao,
            "participaCarne": carneConsult,
            "participaFrangoCong": frangoConsult,
            "participaFrangoCorte": frangoCorteConsult,
            "participaLinguica": linguicaConsult,
            "populacao": populacao,
            "potencialBatata": 0,
            "potencialCarne": 0,
            "potencialFrangoCong": 0,
            "potencialFrangoCorte": 0,
            "potencialLinguica": 0,
            "renda": rendaPerCapita
        }

        const responseConsult = await api.post("/api/consultoria/cadastrar", dataConsult)
    }

    async function handleCreateNewGame() {

        if (rodadas <= 0) {
            alert('Insira o número de rodadas')
            return
        }
        try {
            setLoading(true)

            const dataJogo = {
                "ativo": true,
                "criacaoUsuario": user,
                "negociacaoMaxInteracoes": maxInteracoes,
                "negociacaoTempoLimite": timer,
                "rodadas": rodadas,
                "taxaEmprestimo": Number(taxaEmprestimo ?? 0),
                "taxaInvestimento": Number(taxaInsvestimento ?? 0)
            }

            const responseJogo = await api.post("/api/jogo/criar/", dataJogo)

            if (responseJogo.data.sucesso) {
                handleCreateConsult(responseJogo);
                alert("Novo Jogo Criado")
                clearAll();

            } else {
                alert("Ocorreu um erro ao criar o jogo, recarregue a página e tente novamente.")
            }
            setLoading(false)

        } catch (e) {
            console.log(e);
        }
    }

    return (
        <Container>
            <SizeContainer>
                <BackButton path="/home" />
                <ContainerConsultancy>
                    <ContainerSecunday>
                        <IconConsultancy src={"./images/dado2.svg"} />
                        <TitleConsultancy>Novo Jogo</TitleConsultancy>
                    </ContainerSecunday>
                </ContainerConsultancy>

                {!loading ?
                    <MainContainer>
                        <ContainerTimer>

                            <div>
                                <p>Número de rodadas:</p>
                            </div>
                            <div style={{ marginRight: "20px" }}>
                                <p>rodadas:</p>
                                <input type={"number"} value={rodadas} onChange={(e) => setRodadas(e.target.value)}></input>
                            </div>


                        </ContainerTimer>

                        <ContainerTimer>

                            <div>
                                <p>Tempo de negociação:</p>
                                <span>(Entre indústria e supermercado)</span>
                            </div>
                            <div>
                                <p>Minutos:</p>
                                <input type={"number"} value={timer} onChange={(e) => setTimer(e.target.value)}></input>
                            </div>
                            <div>
                                <p>Interações:</p>
                                <input type={"number"} value={maxInteracoes} onChange={(e) => setMaxInteracoes(e.target.value)}></input>
                            </div>

                            <img src={"./images/consultancy_button.svg"} alt="relógio"></img>

                        </ContainerTimer>

                        <ContainerConsultancy>
                            <ContainerSecundayConsultancy>
                                <IconConsultancy src={"./images/bank_button.svg"} />
                                <TitleConsultancy>Banco</TitleConsultancy>
                            </ContainerSecundayConsultancy>
                        </ContainerConsultancy>

                        <ContainerInputConsultancy>
                            <p>Taxa Empréstimo:</p>
                            <div>
                                <p>%</p>
                                <input type={"number"} value={taxaEmprestimo} onChange={(e) => setTaxaEmprestimo(e.target.value)} ></input>
                            </div>
                        </ContainerInputConsultancy>

                        <ContainerInputConsultancy>
                            <p>Taxa Investimento:</p>
                            <div>
                                <p>%</p>
                                <input type={"number"} value={taxaInsvestimento} onChange={(e) => setTaxaInsvestimento(e.target.value)} ></input>
                            </div>
                        </ContainerInputConsultancy>


                        <ContainerConsultancy>
                            <ContainerSecundayConsultancy>
                                <IconConsultancy src={"./images/consultancy_button.svg"} />
                                <TitleConsultancy>Consultoria</TitleConsultancy>
                            </ContainerSecundayConsultancy>
                        </ContainerConsultancy>

                        <ContainerInputConsultancy>
                            <p>População:</p>
                            <div>
                                <input type={"number"} value={populacao} onChange={(e) => setPopulacao(e.target.value)} ></input>
                            </div>
                        </ContainerInputConsultancy>

                        <ContainerInputConsultancy>
                            <p>Renda per Capita:</p>
                            <div>
                                <p>R$: </p>
                                <input type={"number"} value={rendaPerCapita} onChange={(e) => setRendaPerCapita(e.target.value)} ></input>
                            </div>
                        </ContainerInputConsultancy>

                        <ContainerInputConsultancy>
                            <p>Orçamento de alimentação:</p>
                            <div>
                                <p>%</p>
                                <input type={"number"} value={orcamentoAlimentacao} onChange={(e) => setOrcamentoAlimentacao(e.target.value)} ></input>
                            </div>
                        </ContainerInputConsultancy>

                        <ContainerHeaderConsultancy>
                            <h2>Consumo Anual</h2>
                        </ContainerHeaderConsultancy>

                        <ContainerInputConsultancy>
                            <p>Carne:</p>
                            <div>
                                <p>%</p>
                                <input type={"number"} value={carneConsult} onChange={(e) => setCarneConsult(e.target.value)} ></input>
                            </div>
                        </ContainerInputConsultancy>

                        <ContainerInputConsultancy>
                            <p>Frango:</p>
                            <div>
                                <p>%</p>
                                <input type={"number"} value={frangoConsult} onChange={(e) => setFrangoConsult(e.target.value)} ></input>
                            </div>
                        </ContainerInputConsultancy>

                        <ContainerInputConsultancy>
                            <p>Frango Corte:</p>
                            <div>
                                <p>%</p>
                                <input type={"number"} value={frangoCorteConsult} onChange={(e) => setFrangoCorteConsult(e.target.value)} ></input>
                            </div>
                        </ContainerInputConsultancy>

                        <ContainerInputConsultancy>
                            <p>Linguiça:</p>
                            <div>
                                <p>%</p>
                                <input type={"number"} value={linguicaConsult} onChange={(e) => setLinguicaConsult(e.target.value)} ></input>
                            </div>
                        </ContainerInputConsultancy>



                        <ButtonRequest onClick={() => handleCreateNewGame()}>
                            Criar Novo Jogo
                        </ButtonRequest>

                    </MainContainer> :
                    <Loading />}
            </SizeContainer>
        </Container>
    );
};
export default NewGame;
